<template>
  <div class="preview-container">
    <!-- <div class="header">
      <div class="menu-list"></div>
      <div class="menu-list">
        <h2>预览</h2>
      </div>
      <div class="menu-list">
        <el-button
          icon="el-icon-close"
          circle
          size="mini"
          @click="$emit('close')"
        ></el-button>
      </div>
    </div> -->
    <div class="content" id="preview-content"></div>
  </div>
</template>
<script>
import Axios from "axios";
const IMAGE_URL = location.origin;

async function downloadFile(src) {
  let res = await Axios.get(IMAGE_URL + "/" + src, {
    responseType: "text",
  });
  return res.data;
}
export default {
  props: {
    importConfig: {
      type: String,
      default: () => {
        return ''
      }
    },
    topoKey: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  watch: {
    importConfig(val) {
      if (typeof val === 'string' && val.length > 0) {
        this.init(val)
      }
    },
    topoKey(val) {
      if (!val) return;
      this.findConfig(val)
    }
  },
  data() {
    return {
      loadedStage: false,
      configList: []
    };
  },
  created() {
    this.topology = this.$Core.getProvider("TechnologyTopo");
    this.MQTT = this.$Core.getProvider('MQTT');
    let reconnect = 10;
    // 重连{reconnect}次
    this.MQTT.on('online', (val) => {
      if (val) return;
      --reconnect;
      if (reconnect <= 0) {
        this.$notify({
          title: '提示',
          message: '设备已离线，尝试重连中',
          duration: 30000
        });
        if (!sessionStorage.reloadCount) {
          sessionStorage.reloadCount = 0;
        }
        sessionStorage.reloadCount = Number(sessionStorage.reloadCount) + 1;
        
        if (sessionStorage.reloadCount > 3) {
          this.$confirm('网络错误，设备已离线，尝试重新连接？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(_ => {
            sessionStorage.reloadCount = 0;
            location.reload();
          }).catch(_ => {
            reconnect = 10;
          })
        }else{
          location.reload();
        }
      }
    })
    this.getCloudFile()
    function capitalizeFirstLetter(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    }

    window.addEventListener("message", (e) => {
      let data = e.data;
      let device = data.device;
      if (device) {
        // 转换数据格式
        let d = {};
        Object.keys(device).forEach((key) => {
          d[capitalizeFirstLetter(key)] = device[key];
        });
        this.$Core.getProvider("Auth").device = d;
        this.init();
      }

      if (data.topoConfig) {
        let config = this.topology.deConfig(data.topoConfig);
        this.init(config);
        // this.topoConfig.open(config);
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.init();
      }, 1000);
    });
  },
  methods: {
    findConfig(val) {
      let config = this.configList.find(item => item.key === val)

      if (!config) return;
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      downloadFile(config.url).then(text => {
        let config = this.topology.deConfig(text);

        if (config) {
          this.init(config)
          loading.close();
        }
      })
    },
    async getCloudFile() {
      // 获取线上的配置文件
      let res = await this.topology.TopoComponents.getPagesCloud();

      if (!res.success) {
        this.$message.error(res.message);
      }

      for await (let item of res.data) {
        item.typeData = await this.getTypeCate(item.typeId);
      }

      this.configList = res.data || [];
      console.log(this.configList, "configList")
      if (this.topoKey) {
        this.findConfig(this.topoKey)
      }

    },
    // 获取类型信息执行分类
    async getTypeCate(id) {
      let data = await this.topology.TopoComponents.getType(id);
      return data.data;
    },
    async init(topoConfig) {
      let mqtt = this.$Core.providers.get("MQTT");
      // 切换时重新获取一次mqtt数据
      mqtt.getDeviceAllData()
      this.DPC = this.$Core.getProvider("DPC");
      // 防止重复创建舞台
      if (!this.loadedStage) {
        this.topology.createStage("preview-content", {
          grid: false,
          rule: false,
          padding:5,
          lock: 4,
          locked: 4,
        });
      }
      this.loadedStage = true;
      this.topology.stageCanvas.lock(2);
      try {
        // this.config = localStorage.config;
        // 如果本地存在
        if (!topoConfig) {
          this.config = await this.topology.getConfig();
          if (!this.config) {
            return;
          }

          this.topology.stageCanvas.open(this.config);
        } else {
          this.topology.stageCanvas.open(topoConfig);
        }
      } catch (error) {
        console.log(error);
      }
      this.topology.stageCanvas.inactive();
      this.topology.stageCanvas.lock(4);
      this.topology.stageCanvas.fitView(true, 0);
      this.topology.store.data.grid = false;
      this.topology.store.data.rule = false;
      this.topology.store.data.locked = 4;
      this.topology.store.options.disableTranslate = false;

      this.topology.stageCanvas.setOptions({
        disableRotate: true,
          disableScale: true,
          disableInput: true,
          disableAnchor: false,
          disableTranslate: false,
          hoverColor:"",
          hoverBackground:"",
      })

      this.topology.stageCanvas.render()
      //绑定数据更新
      this.DPC.proc.watch("modules", (val) => {
        // console.log("数据更新", val);
        this.topology.update(val);
      });
      //绑定数据更新
      this.DPC.proc.watch("ctrlMode", (val) => {
        this.topology.update(val);
      });

      // this.topology.stageCanvas.on("valueUpdate", (e) => {
      //   console.log("值更新");
      // });
    },

  },
};
</script>
<style lang="scss" scoped>
.preview-container {
  position: relative;
  inset: 0;
  height: 100%;
  width: 100%;
  background: transparent;

  // z-index: 99;
  .header {
    display: flex;
    height: 44px;
    box-shadow: 0 2px 10px #ccc;
    justify-content: space-between;
    padding: 0 30px;

    .menu-list {
      display: flex;
      align-items: center;
    }
  }

  .content {
    height: 100%;
  }
}
</style>